import store from '@/store'

export default (to, from, next) => {
  if (useCompany(from, to)) {
    if (!hasCompany(from)) {
      const params = new URLSearchParams(to.query).toString()
      window.location.assign('/setup-company' + (params ? `?${params}` : ''))
    } else {
      next({ ...to, query: { ...to.query, company: getCompanyID(from) } })
    }
  } else {
    next()
  }
}

function useCompany(from, to) {
  return store.getters['auth/check'] && to.meta.company && !to.query.company
}

function hasCompany(from) {
  return !!from.query.company || !!store.getters['auth/activeCompany']
}

function getCompanyID(from) {
  return from.query.company || store.getters['auth/activeCompany'].id
}
